var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import {
  useMutation,
  useQuery
} from "react-query";
import { eNoteApiRequest } from "./client";
import { useState } from "react";
import { mergeFunctionCalls } from "../util";
const fetchENote = (eNoteKeys) => {
  return eNoteApiRequest({
    url: `/e-note/student/${eNoteKeys.studentId}/enrollment/${eNoteKeys.enrollmentId}/lesson/${eNoteKeys.lessonId}`,
    method: "GET"
  });
};
const createENote = (eNoteKeys, eNote) => {
  return eNoteApiRequest({
    url: `/e-note/student/${eNoteKeys.studentId}/enrollment/${eNoteKeys.enrollmentId}/lesson/${eNoteKeys.lessonId}`,
    method: "POST",
    data: eNote
  });
};
const updateENote = (eNoteKeys, eNote) => {
  return eNoteApiRequest({
    url: `/e-note/student/${eNoteKeys.studentId}/enrollment/${eNoteKeys.enrollmentId}/lesson/${eNoteKeys.lessonId}`,
    method: "PATCH",
    data: eNote
  });
};
const uploadENoteImage = (eNoteKeys, image) => {
  const formData = new FormData();
  formData.append("image", image);
  return eNoteApiRequest({
    url: `/e-note/image/student/${eNoteKeys.studentId}/enrollment/${eNoteKeys.enrollmentId}`,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: formData
  });
};
const useENoteQuery = (eNoteKeys, options) => {
  return useQuery(
    ["e-note", eNoteKeys.studentId, eNoteKeys.enrollmentId, eNoteKeys.lessonId],
    () => fetchENote(eNoteKeys),
    options
  );
};
const useCreateENoteMutation = (eNoteKeys, options) => {
  return useMutation(
    [
      "createENoteMutation",
      eNoteKeys.studentId,
      eNoteKeys.enrollmentId,
      eNoteKeys.lessonId
    ],
    (eNote) => createENote(eNoteKeys, eNote),
    options
  );
};
const useUpdateENoteMutation = (eNoteKeys, options) => {
  return useMutation(
    [
      "updateENoteMutation",
      eNoteKeys.studentId,
      eNoteKeys.enrollmentId,
      eNoteKeys.lessonId
    ],
    (eNote) => updateENote(eNoteKeys, eNote),
    options
  );
};
function useUpsertENoteMutation(eNoteKeys, options) {
  var _a;
  const [allowUpdate, setAllowUpdate] = useState(false);
  const allowQuery = !!(eNoteKeys == null ? void 0 : eNoteKeys.studentId) && !!(eNoteKeys == null ? void 0 : eNoteKeys.enrollmentId) && !!(eNoteKeys == null ? void 0 : eNoteKeys.lessonId);
  const onCreate = () => setAllowUpdate(true);
  const onQuery = (eNote) => {
    if (eNote)
      setAllowUpdate(true);
  };
  const {
    data: initialState,
    isLoading: isQueryLoading,
    isError: isQueryError,
    refetch
  } = useENoteQuery(eNoteKeys, __spreadValues({
    onSuccess: onQuery,
    enabled: allowQuery
  }, options == null ? void 0 : options.queryENoteOptions));
  const {
    mutate: create,
    mutateAsync: createAsync,
    isLoading: isCreateLoading,
    isError: isCreateMutationError
  } = useCreateENoteMutation(eNoteKeys, __spreadProps(__spreadValues({}, options == null ? void 0 : options.createENoteOptions), {
    onSuccess: mergeFunctionCalls(
      onCreate,
      (_a = options == null ? void 0 : options.createENoteOptions) == null ? void 0 : _a.onSuccess
    )
  }));
  const {
    mutate: update,
    mutateAsync: updateAsync,
    isLoading: isUpdateLoading,
    isError: isUpdateMutationError
  } = useUpdateENoteMutation(eNoteKeys, __spreadValues({}, options == null ? void 0 : options.updateENoteOptions));
  const mutate = (eNote) => {
    if (isQueryLoading)
      return;
    if (allowUpdate)
      update(eNote);
    else
      create(eNote);
  };
  const mutateAsync = (eNote) => {
    if (isQueryLoading)
      return Promise.resolve();
    if (allowUpdate)
      return updateAsync(eNote);
    else
      return createAsync(eNote);
  };
  return {
    mutate,
    mutateAsync,
    resetInitialState: refetch,
    initialState,
    isMutationLoading: isCreateLoading || isUpdateLoading,
    isQueryLoading,
    isError: isQueryError || isCreateMutationError || isUpdateMutationError
  };
}
function useENoteImageUploadMutation() {
  return useMutation(
    ({ eNoteKeys, image }) => uploadENoteImage(eNoteKeys, image)
  );
}
export {
  useCreateENoteMutation,
  useENoteImageUploadMutation,
  useENoteQuery,
  useUpdateENoteMutation,
  useUpsertENoteMutation
};
